import React from 'react';

const FooterIcon = props => {
  const isSeparateCinema = props.cinema.is_separate_cinema;
  const noBonus = props.cinema.no_bonus;
  const rent = props.cinema.rent;

  const useBonusAppText = () => (
    <div className="checkout-result__note">
      <p className="checkout-result__msg attention-msg">
        Воспользоваться баллами можно{' '}
        <a href="https://app.comfortkino.ru" target="_blank">
          в приложении
        </a>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
          <path
            fill="#f1ca0f"
            d="M24.8 8.3l-3.8-4.9c-.2-.3-.5-.4-.9-.4h-15.2c-.4 0-.7.1-.9.4l-3.8 4.9c-.3.4-.3 1 .1 1.4l11.5 11.8c.4.4 1.1.4 1.5 0l11.4-11.9c.4-.3.4-.9.1-1.3zm-13.2-3.2h1.8l2.2 2.8h-6.2l2.2-2.8zm-6.2 0h3.6l-2.2 2.8h-3.6l2.2-2.8zm-1.9 4.8h3.5l2.4 6-5.9-6zm9 8.3l-3.3-8.3h6.6l-3.3 8.3zm3.2-2.2l2.4-6h3.4l-5.8 6zm2.5-8.1l-2.2-2.8h3.6l2.2 2.8h-3.6z"
          ></path>
        </svg>
      </p>
    </div>
  );
  if (!isSeparateCinema && noBonus && !rent) {
    return useBonusAppText();
  }

  if ((noBonus && isSeparateCinema) || rent) return null;

  if (props.user.phone) {
    // Есть карта
    if (props.user.card) {
      return (
        <div className="checkout-result__note">
          <p className="checkout-result__msg attention-msg">
            При оплате бонусами минимальная<br />
            стоимость билета - 1 рубль
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25">
              <path
                fill="#f1ca0f"
                d="M24.8 8.3l-3.8-4.9c-.2-.3-.5-.4-.9-.4h-15.2c-.4 0-.7.1-.9.4l-3.8 4.9c-.3.4-.3 1 .1 1.4l11.5 11.8c.4.4 1.1.4 1.5 0l11.4-11.9c.4-.3.4-.9.1-1.3zm-13.2-3.2h1.8l2.2 2.8h-6.2l2.2-2.8zm-6.2 0h3.6l-2.2 2.8h-3.6l2.2-2.8zm-1.9 4.8h3.5l2.4 6-5.9-6zm9 8.3l-3.3-8.3h6.6l-3.3 8.3zm3.2-2.2l2.4-6h3.4l-5.8 6zm2.5-8.1l-2.2-2.8h3.6l2.2 2.8h-3.6z"
              ></path>
            </svg>
          </p>
        </div>
      );
    } else {
      // Нет карты
      return (
        <div className="checkout-result__note">
          <div className="checkout-result__card">
            <div className="pic">
              <img src={props.user.card_img} />
            </div>
            <p>
              <span>
                Нет бонусной карты.
                <br />
                <a target="_blank" href="/about/bonus">
                  Как получить?
                </a>
              </span>
            </p>
          </div>
        </div>
      );
    }
  } else {
    // Не авторизован
    return (
      <div className="checkout-result__note">
        <p className="checkout-result__msg attention-msg">
          Для начисления и оплаты бонусами&nbsp;
          <button onClick={() => props.onLogin()}>авторизуйтесь</button>
          <svg width="20" height="18">
            <path d="M19.8 15.5l-8.4-14.7c-.4-.8-1.4-1-2.2-.6-.3.2-.5.4-.6.6l-8.4 14.7c-.5.8-.2 1.8.6 2.3.3.1.6.2.9.2h16.7c.9 0 1.7-.8 1.7-1.7-.1-.3-.2-.6-.3-.8zm-18.1.8l8.3-14.6 8.3 14.6h-16.6zm8.3-3.9c-.6 0-1.1.5-1.1 1.1 0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1c0-.6-.5-1.1-1.1-1.1zm-1.1-5.1v.2l.5 3.3c.1.3.3.5.6.5.2 0 .4-.2.5-.5l.5-3.3v-.2c0-.6-.5-1.1-1.1-1.1-.5 0-1 .5-1 1.1z" />
          </svg>
        </p>
      </div>
    );
  }
};

export default FooterIcon;
